import { createContext, useContext } from 'react'
import type { DesignElement } from '@/types/blocks'

interface QuickToolbarContextValue {
  /** Панель под элементом — списки раскрываются вниз; над ним — вверх. Так они
   *  уходят в сторону от элемента и не закрывают его. */
  below: boolean
  /** Примерка значения из списка при наведении (`null` — вернуть как было). */
  preview: (patch: Partial<DesignElement> | null) => void
}

export const QuickToolbarContext = createContext<QuickToolbarContextValue>({
  below: false,
  preview: () => {},
})

export const useQuickToolbar = () => useContext(QuickToolbarContext)

/** Заморозка позиции панели, пока открыт список: примерка меняет высоту элемента,
 *  и панель под ним иначе ехала бы из-под неподвижной мыши. */
export const ToolbarFreezeContext = createContext<(frozen: boolean) => void>(() => {})

export const useToolbarFreeze = () => useContext(ToolbarFreezeContext)

/** Где фактически стоит панель — под элементом (`true`) или над ним. Решает
 *  обёртка (`SortableDesignElement`) по месту на холсте; `null` — снаружи обёртки. */
export const ToolbarBelowContext = createContext<boolean | null>(null)

/** Сторона панели: фактическая от обёртки, иначе — подсказка холста. */
export const useToolbarBelow = () => {
  const actual = useContext(ToolbarBelowContext)
  const { below } = useQuickToolbar()
  return actual ?? below
}
